/**
 * Unidades de compra e consumo de material.
 *
 * Lista fechada na tela, campo de texto livre no banco: o laboratório escolhe destas na maioria
 * esmagadora dos casos, e quando precisa de uma que não está aqui (folha, par, kit) digita a dele.
 * Virar enum no schema seria travar o cadastro por causa do caso raro.
 */
export const UNIDADES = [
  { valor: "UN", rotulo: "UN — unidade" },
  { valor: "PC", rotulo: "PC — peça" },
  { valor: "CX", rotulo: "CX — caixa" },
  { valor: "KIT", rotulo: "KIT — kit" },
  { valor: "L", rotulo: "L — litro" },
  { valor: "ml", rotulo: "ml — mililitro" },
  { valor: "kg", rotulo: "kg — quilo" },
  { valor: "g", rotulo: "g — grama" },
  { valor: "mg", rotulo: "mg — miligrama" },
  { valor: "m", rotulo: "m — metro" },
  { valor: "cm", rotulo: "cm — centímetro" },
] as const;

export const OUTRA_UNIDADE = "__outra__";

/** Material antigo (ou importado) pode ter unidade fora da lista — ela precisa continuar aparecendo
 *  selecionada, senão editar o material a apagaria sem ninguém perceber. */
export function unidadesComAtual(atual: string) {
  const u = atual.trim();
  if (!u || UNIDADES.some((x) => x.valor === u)) return UNIDADES;
  return [...UNIDADES, { valor: u, rotulo: u }];
}
